import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-the-c01-form-note-panel-gift-card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "p-the-c01-form-note-panel-gift-card__content" }, [
      _createTextVNode(" カートに商品が入っておりますので、先にご精算をお願いいたします。"),
      _createElementVNode("br"),
      _createTextVNode("※現在、1種類ごとにお申込み、ご精算をお願いしております"),
      _createElementVNode("br"),
      _createTextVNode("※個数の変更が出来ない商品は、1枚ごとのお申し込み商品となります。 ")
    ], -1)
  ])))
}